import React, {useEffect, useState} from 'react';
import FaqComponent from '../../../Components/UserComponents/Faq';

const FaqContainer = () => {
  return <FaqComponent />;
};

export default FaqContainer;
